export default "__VITE_PUBLIC_ASSET__422318bf__"